export default "__VITE_ASSET__BAU4fMGD__"